import { mobileMenuToggle } from '../../src/js/events';

export default class Hamburger {
  constructor($el) {
    this.$el = document.querySelector('.js-hamburger');
    this.activeClass = 'is-active';
    this.$el && this.$el.addEventListener('click', this.onClick.bind(this));
  }

  /**
   * @function onClick
   * @param {Event} e
   */
  onClick(e) {
    e.preventDefault();
    this.$el.classList.toggle(this.activeClass);
    window.dispatchEvent(new Event(mobileMenuToggle));
  }
}
